import styled from 'styled-components';
import React from "react";

import Primary from './Buttons/Primary-Button';

const Title = styled.h1`
  font-weight: 600;
  color: #223461;
  font-size: 30px;
  margin-bottom: 10px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 20px;
  line-height: 1.5;
`;

const SubTitle = styled.div`
  font-size: 18px;
  text-align: center;
  padding-bottom: 20px;
  padding-left: 100px;
  padding-right: 100px;
  color: #667988;
  @media only screen and (max-width: 700px) {
    padding-left: 30px;
    padding-right: 30px;
  }
`;

const Wrapper = styled.div`
  justify-content: center;
  display: flex;
  flex-direction: row;
  @media only screen and (max-width: 1000px) {
    flex-direction: column;
    margin-bottom: 50px;
  }
`;

const Input = styled.div`
  width: 500px;
  border-radius: 8px;
  @media only screen and (max-width: 550px) {
    width: 70%;
  }
`;

export default props => {
  const handleClick = () => {
    if (document.querySelector('#email').value.trim()) {
      window.location = `/contact?email=${document.querySelector('#email').value.trim()}`;
    }
  };
  return (
    <div style={{ textAlign: 'center', paddingTop: '40px', paddingBottom: '40px' }}>
      <Title>{props.title}</Title>
      <SubTitle>{props.sub}</SubTitle>
      <Wrapper className="valign-wrapper">
        <Input className="input-field col s6">
          <input
            id="email"
            style={{
              padding: '10px',
              background: 'white',
              width: '100%',
              border: '2px #eee solid',
              borderRadius: '8px',
            }}
            placeholder="yourname@companyname.com"
            type="email"
            className="validate browser-default"
          />
        </Input>
        <div>
          <Primary onClick={() => handleClick()} className="btn waves-effect waves-light red">
            {props.cta}
          </Primary>
        </div>
      </Wrapper>
    </div>
  );
};
